/**
 * CR-9121: the haulier's active-filter chip above the Call Off list.
 *
 * A haulier has no Active / Completed / Cancelled toggle (CR-7732), so a stat
 * card it is drilled into — including the Logistics Confirmed card it lands
 * on — needs its own visible way back to every load. Clearing it shows the
 * whole list again, delivered and cancelled loads included.
 *
 * @link CallOffManagementTab for the consumer.
 */
import { Button } from '../../ui/button';
import { X } from 'lucide-react';

interface CallOffHaulierFilterChipProps {
  /** The drilled-in card's label, e.g. "Logistics Confirmed". */
  label: string;
  onClear: () => void;
}

export default function CallOffHaulierFilterChip({ label, onClear }: CallOffHaulierFilterChipProps) {
  return (
    <div className="flex items-center gap-2 text-sm">
      <span className="text-muted-foreground">Showing</span>
      <Button
        variant="secondary"
        size="sm"
        className="h-7 gap-1 rounded-full px-3"
        aria-label={`Clear filter: ${label}`}
        title="Clear the filter to see every load, delivered and cancelled included"
        onClick={onClear}
      >
        {label}
        <X className="h-3.5 w-3.5" />
      </Button>
    </div>
  );
}
